import axios from 'axios';
import { attachSecurityInterceptors } from './securityInterceptor';
import { attachAuthInterceptors } from './authInterceptor';
import { ENV } from '../../config/env';

/**
 * The single configured axios instance every service in this app uses.
 *
 * All services should `import { apiClient } from '@/services/_shared/apiClient'`
 * rather than `import axios from 'axios'`. The only exceptions are the
 * auth-bootstrap services that have to run BEFORE this client is initialized
 * (`keycloakAuthService`, `keycloakDirectAuth`) — those keep using default `axios` so the
 * apiClient's own interceptors can call back into them (e.g.
 * `refreshToken`, `getStoredCredentials`) without recursing.
 *
 * Same shape across PE / admin / webapp; only the imported
 * `attachAuthInterceptors` / `attachSecurityInterceptors` differ per app
 * because each app's auth-storage + refresh contract is slightly different.
 *
 * Webapp specifics:
 *   - No cookie-auth branch (token-based only, via encrypted SecureStorage).
 *   - `attachSecurityInterceptors` is a REAL implementation here (rate-limit
 *     + CSRF + sanitization) — see `securityInterceptor.ts`. PE's version of
 *     the same file is currently a no-op stub.
 */

export const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-App-Source': ENV.APP_SOURCE,
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// Wire up the cross-cutting concerns. Security first (rate limit, CSRF,
// sanitization) so any short-circuit happens before we spend cycles on
// token plumbing.
attachSecurityInterceptors(apiClient);
attachAuthInterceptors(apiClient);

export default apiClient;
